import { useEffect, useState } from "react";
import { appConfig } from "../app-config";
import { Button, Checkbox, Divider, FormControlLabel, FormGroup, Typography } from "@mui/material";
import ErrorInfo from '../assets/error-info.svg';
import * as formatters from '../utils/util';
import langDetails from '../components/MultiLanguage/language.json';

const DonorTaxInformation = ({ handleNext, sharedData, updateSharedData }) => {
  const lang = langDetails[sharedData?.language];

  const [emailErrMessage, setEmailErrMessage] = useState('');
  const [firstNameErrMessage, setFirstNameErrMessage] = useState('');
  const [lastNameErrMessage, setLastNameErrMessage] = useState('');
  const [addressOneErrMessage, setAddressOneErrMessage] = useState('');
  // const [addressTwoErrMessage, setAddressTwoErrMessage] = useState('');
  const [cityErrMessage, setCityErrMessage] = useState('');
  const [countryErrMessage, setCountryErrMessage] = useState('');
  const [codeErrMessage, setCodeErrMessage] = useState('');
  const [provinceErrMessage, setProvinceErrMessage] = useState('');

  const [youGive, setYouGive] = useState(sharedData?.donationAmount?.youGive  || 0);
  const [creditApplied, setCreditApplied] = useState(sharedData?.donationAmount?.creditApplied || 0.00);
  const [totalAmount, setTotalAmount] = useState((creditApplied + Number(youGive)) || sharedData?.donationAmount?.totalAmount || 0);

  const [emailValue, setEmailValue] = useState("");
  const [firstNameValue, setFirstNameValue] = useState("");
  const [lastNameValue, setLastNameValue] = useState("");
  const [addressOneValue, setAddressOneValue] = useState("");
  const [addressTwoValue, setAddressTwoValue] = useState("");
  const [cityValue, setCityValue] = useState("");
  const [countryValue, setCountryValue] = useState("");
  const [codeValue, setCodeValue] = useState("");
  const [provinceValue, setProvinceValue] = useState("");

  const [reciveCheck, setreciveCheck] = useState(false);

  const [donorData, setDonorData] = useState({

    reciveCheck: false,
    // emailId: '',
    firstName: '',
    lastName: '',
    addressOne: '',
    addressTwo: '',
    city: '',
    country: '',
    postalCode: '',
    province: '',
    youGive:'',
    givesomeTip:'',
    total:''

  });

  
  const [currency, setCurrency] = useState(sharedData?.donationAmount?.currency ? sharedData?.donationAmount?.currency : "");
  const [currencySymbol, setCurrencySymbol] = useState(sharedData?.donationAmount?.currencySymbol);
  const [currencyError, setCurrencyError] = useState('');

  useEffect(()=>{
    
   setYouGive(sharedData?.donationAmount?.youGive  || 0);
   setCreditApplied(sharedData?.donationAmount?.creditApplied || 0.00);
   setTotalAmount((creditApplied + Number(youGive)) || sharedData?.donationAmount?.totalAmount || 0);
  

    if(sharedData?.donationAmount?.currencySymbol) {
      setCurrencySymbol(sharedData?.donationAmount?.currencySymbol)
    } 
  },[sharedData?.donationAmount?.currencySymbol])

  const handleChange = (event) => {
    const { name, value, checked } = event.target;
    // if (name === "emailId") {
    //   setEmailErrMessage("");
    // }
    if (name === "firstName") {
      setFirstNameErrMessage("");
    }
    if (name === "lastName") {
      setLastNameErrMessage("");
    }
    if (name === "addressOne") {
      setAddressOneErrMessage("");
    }
    // if (name === "addressTwo") {
    //   setAddressTwoErrMessage("");
    // }
    if (name === "city") {
      setCityErrMessage("");
    }
    if (name === "country") {
      setCountryErrMessage("");
    }
    if (name === "code") {
      setCodeErrMessage("");
    }
    if (name === "province") {
      setProvinceErrMessage("");
    }
    if (name === "reciveCheck") {
      setEmailErrMessage("");
      setFirstNameErrMessage("");
      setLastNameErrMessage("");
      setAddressOneErrMessage("");
      // setAddressTwoErrMessage("");
      setCityErrMessage("");
      setCountryErrMessage("");
      setCodeErrMessage("");
      setProvinceErrMessage("");
    }
    setDonorData((prevFormData) => ({ ...prevFormData, [name]: value }));
    setDonorData((prevFormData) => ({
      ...prevFormData,
      reciveCheck: prevFormData.reciveCheck === "on" ? "true" : "false",
    }));
  };

  const onConfirmDonorTaxInfo = () => {
    setDonorData({
      ...donorData,
      // youGive:youGive,
      // givesomeTip:creditApplied,
      // total:totalAmount,
      ...sharedData
    });
    if (!reciveCheck) {
      let validation = true;
      let code = donorData.code;
      // if (donorData.emailId === "") {
      //   setEmailErrMessage("This is Required");
      //   validation = false;
      // }
      // else if (!formatters.isEmail(donorData.emailId)) {
      //   setEmailErrMessage("Enter Valid Email");
      //   validation = false;
      // }
      if (donorData.firstName === "") {
        setFirstNameErrMessage("This is Required");
        validation = false;
      }
      else if(!formatters.isAlphabetic(donorData.firstName)){
        setFirstNameErrMessage(" Invalid characters");
        validation = false;
      }
      if (donorData.lastName === "") {
        setLastNameErrMessage("This is Required");
        validation = false;
      }
      else if(!formatters.isAlphabetic(donorData.lastName)){
        setLastNameErrMessage(" Invalid characters");
        validation = false;
      }
      if (donorData.addressOne === "") {
        setAddressOneErrMessage("This is Required");
        validation = false;
      }
      // if (donorData.addressTwo === "") {
      //   setAddressTwoErrMessage("This is Required");
      //   validation = false;
      // }
      if (donorData.city === "") {
        setCityErrMessage("This is Required");
        validation = false;
      }
      if (donorData.country === "") {
        setCountryErrMessage("This is Required");
        validation = false;
      }
      if (donorData.code === "") {
        setCodeErrMessage("This is Required");
        validation = false;
      }
      // else if (!formatters.PostalCode(code)) {
      //   setCodeErrMessage("Enter Valid Code");
      //   validation = false;
      // }
      if (donorData.province === "") {
        setProvinceErrMessage("This is Required");
        validation = false;
      }
      if (validation) {
     
        const updatedData = { ...sharedData, donorData };
        updateSharedData(updatedData);
        handleNext(3);
      }
    } else {
      setDonorData({
        ...donorData,
        reciveCheck:reciveCheck,
        firstName: '',
        lastName: '',
        addressOne: '',
        addressTwo: '',
        city: '', 
        country: '',
        postalCode: '',
        province: '',
        // youGive:youGive, 
        // givesomeTip:creditApplied,
        // total:totalAmount
      });
      const updatedData = { ...sharedData, donorData };
      updateSharedData(updatedData);
      handleNext(3); 
    }

  }

  return (
    <div >
      <div className="mb-30" style={{ textAlign: 'left' }}>
        <Typography className='query-head' style={{ paddingTop: 20, color: '#111' }}>{lang?.DonorAndTaxInfo}</Typography>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <FormGroup>
          <FormControlLabel control={
            <Checkbox
              checked={reciveCheck}
              size="small"
              sx={{
                color: "#D9D9D9", //#5D4294
                '&.Mui-checked': {
                  color: "#5D4294",
                },
              }}
              name="reciveCheck"
              // value={donorData.reciveCheck}
              onChange={(e) => { setreciveCheck(!reciveCheck); handleChange(e); }}
            />
          } label={<Typography className="normal-text">{lang?.IDoNotWishToReceiveAReceipt}</Typography>} />
        </FormGroup>
      </div>
      {!reciveCheck && <div>
        <div className='mb-10' >
          <div className="mt-30">
            <Typography className="sub-head">{lang?.CanadaRevenueRequires}</Typography>
          </div>

          {/* <div className="apply-amount mt-10">
            <input className='amount-input placeholder-text sub-head'
              type="text"
              placeholder={lang?.EmailAddress}
              // style={{ textTransform: 'uppercase' }}
              value={donorData.emailId}
              name="emailId"
              onChange={handleChange}
            />
            {emailErrMessage !== '' && (<p className="normal-text" id="err-msg" style={{ color: '#FF0000', display: 'flex', alignItems: 'center', gap: 10 }}><img class="" height="15px" width="15px" src={ErrorInfo} /> {emailErrMessage}</p>)}

          </div> */}

          <div className="apply-amount mt-10">

            <div className="flex-space-btw ">
              <div className="w-50" style={{ display: 'flex', flexDirection: 'column' }}>
                <input className='amount-input placeholder-text sub-head'
                  type="text"
                  placeholder={lang?.FirstName}
                  // style={{ textTransform: 'uppercase' }}
                  name="firstName"
                  value={donorData.firstName}
                  onChange={handleChange}
                />
                {firstNameErrMessage !== '' && (<p className="normal-text" id="err-msg" style={{ color: '#FF0000', display: 'flex', alignItems: 'center', gap: 10 }}><img class="" height="15px" width="15px" src={ErrorInfo} /> {firstNameErrMessage}</p>)}
              </div>
              <div className="w-50" style={{ display: 'flex', flexDirection: 'column' }}>
                <input className='amount-input placeholder-text sub-head'
                  type="text"
                  placeholder={lang?.LastName}
                  // style={{ textTransform: 'uppercase' }}
                  name="lastName"
                  value={donorData.lastName}
                  onChange={handleChange}
                />
                {lastNameErrMessage !== '' && (<p className="normal-text" id="err-msg" style={{ color: '#FF0000', display: 'flex', alignItems: 'center', gap: 10 }}><img class="" height="15px" width="15px" src={ErrorInfo} /> {lastNameErrMessage}</p>)}
              </div>

            </div>
          </div>
        </div>

        <div >
          {/* <div className="mt-30">
            <Typography className="sub-head">{lang?.Address}</Typography>
          </div> */}

          <div className="apply-amount mt-10">
            <input className='amount-input placeholder-text sub-head'
              type="text"
              placeholder={lang?.AddressLine1}
              // style={{ textTransform: 'uppercase' }}
              name="addressOne"
              value={donorData.addressOne}
              onChange={handleChange}
            />
            {addressOneErrMessage !== '' && (<p className="normal-text" id="err-msg" style={{ color: '#FF0000', display: 'flex', alignItems: 'center', gap: 10 }}><img class="" height="15px" width="15px" src={ErrorInfo} /> {addressOneErrMessage}</p>)}
          </div>

          <div className="apply-amount mt-10">
            <input className='amount-input placeholder-text sub-head'
              type="text"
              placeholder={lang?.AddressLine2}
              // style={{ textTransform: 'uppercase' }}
              name="addressTwo"
              value={donorData.addressTwo}
              onChange={handleChange}
            />
            {/* {addressTwoErrMessage !== '' && (<p className="normal-text" id="err-msg" style={{ color: '#FF0000', display: 'flex', alignItems: 'center', gap: 10 }}><img class="" height="15px" width="15px" src={ErrorInfo} /> {addressTwoErrMessage}</p>)} */}

          </div>

          <div className="apply-amount mt-10">
            <div className="flex-space-btw ">
              <div className="w-50" style={{ display: 'flex', flexDirection: 'column' }}>

                <input className='amount-input placeholder-text sub-head'
                  type="text"
                  placeholder={lang?.City}
                  // style={{ textTransform: 'uppercase' }}
                  name="city"
                  value={donorData.city}
                  onChange={handleChange}
                />
                {cityErrMessage !== '' && (<p className="normal-text" id="err-msg" style={{ color: '#FF0000', display: 'flex', alignItems: 'center', gap: 10 }}><img class="" height="15px" width="15px" src={ErrorInfo} /> {cityErrMessage}</p>)}
              </div>
              <div className="w-50" style={{ display: 'flex', flexDirection: 'column' }}>
                <input className='amount-input placeholder-text sub-head'
                  type="text"
                  placeholder={lang?.Country}
                  // style={{ textTransform: 'uppercase' }}
                  name="country"
                  value={donorData.country}
                  onChange={handleChange}
                />
                {countryErrMessage !== '' && (<p className="normal-text" id="err-msg" style={{ color: '#FF0000', display: 'flex', alignItems: 'center', gap: 10 }}><img class="" height="15px" width="15px" src={ErrorInfo} /> {countryErrMessage}</p>)}

              </div>
            </div>
          </div>

          <div className="apply-amount mt-10">
            <div className="flex-space-btw ">
              <div className="w-50" style={{ display: 'flex', flexDirection: 'column' }}>
                <input className='amount-input placeholder-text sub-head'
                  type="text"
                  placeholder={lang?.PostalCode}
                  maxLength={7}
                  style={{ textTransform: 'uppercase' }}
                  name="code"
                  value={donorData.code}
                  onChange={handleChange}
                />
                {codeErrMessage !== '' && (<p className="normal-text" id="err-msg" style={{ color: '#FF0000', display: 'flex', alignItems: 'center', gap: 10 }}><img class="" height="15px" width="15px" src={ErrorInfo} /> {codeErrMessage}</p>)}
              </div>
              <div className="w-50" style={{ display: 'flex', flexDirection: 'column' }}>
                <input className='amount-input placeholder-text sub-head'
                  type="text"
                  placeholder={lang?.Province}
                  // style={{ textTransform: 'uppercase' }}
                  name="province"
                  value={donorData.province}
                  onChange={handleChange}
                />
                {provinceErrMessage !== '' && (<p className="normal-text" id="err-msg" style={{ color: '#FF0000', display: 'flex', alignItems: 'center', gap: 10 }}><img class="" height="15px" width="15px" src={ErrorInfo} /> {provinceErrMessage}</p>)}
              </div>
            </div>
          </div>
        </div>
      </div>}

      <div className="mb-30 mt-30">

        <div>
          <Typography className="sub-head ">{lang?.YourDonation}</Typography>
        </div>

        <div className="flex-space-btw mt-20 ">
          <Typography className="normal-text">{lang?.YouGive}</Typography>
          <Typography className="normal-text"> {sharedData?.donationAmount?.currencySymbol} {youGive.toString().includes(".") ? youGive : youGive+".00"}</Typography>
        </div>

        {/* <div> */}
          <div className="flex-space-btw ">
            <Typography className="normal-text">{lang?.GivesomeTip}</Typography>
            <Typography className="normal-text">{sharedData?.donationAmount?.currencySymbol} {creditApplied.toString().includes(".") ? creditApplied.toFixed(2) : creditApplied+".00"}</Typography>
          </div>
            <Divider className="divider1" sx={{ mt: '10px !important' }} />
        {/* </div> */}

        <div className="flex-space-btw">
          <Typography className="sub-head">{lang?.total}</Typography>
          <Typography className="sub-head"> {sharedData?.donationAmount?.currency}{sharedData?.donationAmount?.currencySymbol} {totalAmount.toString().includes(".") ? totalAmount.toFixed(2) : totalAmount+".00"}</Typography>
        </div>
      </div>

      <Button className="normal-text next-btn" variant='contained'
        onClick={onConfirmDonorTaxInfo}
      >
        {lang?.next}
      </Button>

    </div>
  );
};



export default DonorTaxInformation